export enum CategoryFooterDescriptionDataHook {
  Root = 'CategoryFooterDescriptionDataHook.Root',
  Viewer = 'CategoryFooterDescriptionDataHook.Viewer',
  ReadMoreButton = 'CategoryFooterDescriptionDataHook.ReadMoreButton',
  ContentContainer = 'CategoryFooterDescriptionDataHook.ContentContainer',
}
